import { render } from "./ModalRemoveCustomerDomain.vue?vue&type=template&id=67bb2cb0"
import script from "./ModalRemoveCustomerDomain.vue?vue&type=script&lang=js"
export * from "./ModalRemoveCustomerDomain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__